import React, { VFC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  ABOUT,
  BUSINESSES,
  PLANS,
  EXPERIENCE,
  BUSINESS,
} from '../../../constants/routing';
import { useTheme, Theme } from '@material-ui/core/styles';
import GreenButtonLink from '../atoms/GreenButtonLink';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #f5f3f3;
`;
const Link = styled.a<{ color: string; theme: Theme }>`
  font-size: 15px;
  color: ${({ color }) => color};
  margin-right: ${({ theme }) => theme.spacing(5)}px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${({ color }) => color};
    text-underline-offset: 5px;
  }
`;
const BusinessLinkWrapper = styled.div`
  position: absolute;
  right: 5%;
`;

interface Props {}
const SubHeader: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Wrapper>
      <Link href={ABOUT} color="#fe6e2d" theme={theme}>
        {t('header.about')}
      </Link>
      <Link href={BUSINESSES} color="#26bcba" theme={theme}>
        {t('header.businesses')}
      </Link>
      <Link href={PLANS} color="#3e71ce" theme={theme}>
        {t('header.plans')}
      </Link>
      <Link
        href={EXPERIENCE}
        color="#d87235"
        target="_blank"
        rel="noopener"
        theme={theme}
      >
        {t('header.experience')}
      </Link>
      <BusinessLinkWrapper>
        <GreenButtonLink href={BUSINESS} target="_blank">
          {t('header.business')}
        </GreenButtonLink>
      </BusinessLinkWrapper>
    </Wrapper>
  );
};

export default SubHeader;
